export class DepartmentsModel {
    dept_id: number
    dept_desc: string
    dept_note: string

    constructor(
        dept_id: number,
        dept_desc: string,
        dept_note: string
    ) {
        this.dept_id = dept_id
        this.dept_desc = dept_desc
        this.dept_note = dept_note
    }
}